<div class="wrapper" style="padding-top: 32px;">
    <div class="filter-section">
        <div>
            <span style="font-weight: 600;font-size: 20px;">{{competencyName}}</span>
        </div>
        <div style="display: flex; gap: 5px;">
            <div>
                <mat-form-field class="transparent-select subcomp custom_select mr-2">
                    <mat-select
                        class="dropdown-select"
                        [(ngModel)]="highlightedLabel"
                        placeholder="Service Areas"
                    >
                        <mat-option
                            *ngFor="let legendItem of legendItems; let i = index"
                            (click)="onLegendItemClick(legendItem.label, i)"
                            [value]="legendItem.label"
                        >
                            <div class="service-area-option">
                                <div>
                                    <span
                                        class="legend-marker"
                                        [style.backgroundColor]="legendItem.color"
                                    ></span>
                                </div>
                                <div style="font-size: 12px;">{{ legendItem.label }}</div>
                            </div>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="transparent-select subcomp custom_select mr-2">
                    <mat-select
                        class="dropdown-select"
                        [(ngModel)]="selectedSubCompetency"
                        placeholder="Sub-competency"
                        multiple
                    >
                        <mat-option
                            *ngFor="let i of subCompForDropDown"
                            [value]="i"
                            class="dropdown-opiton"
                            (click)="toggleSubCompDropdown(i)"
                        >
                            <span class="optionValue">{{ i.name }}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="transparent-select skill custom_select mr-2">
                    <mat-select
                        class="dropdown-select"
                        [(ngModel)]="selectedSkills"
                        placeholder="Skills"
                        multiple>
                        <mat-option
                            *ngFor="let i of skillsForDropDown"
                            [value]="i"
                            class="dropdown-opiton"
                            (click)="toggleSkills(i)"
                        >
                            <span class="optionValue">{{ i.name }}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="top-section">
        <div class="left-section">
            <span class="chart-heading">Service Areas</span>
            <div class="pie-chart1">
                <p-chart
                    style="margin-right: 10px;"
                    type="doughnut"
                    #chart1
                    [data]="subCompetencyDistributionChartData"
                    [options]="subComptenciesChartOptions"
                    height="280px"
                    width="280px"
                />
                <ul class="service-legend">
                    <li *ngFor="let legendItem of legendItems; let i = index">
                        <div>
                            <span
                                class="legend-marker"
                                [style.backgroundColor]="legendItem.color"
                            ></span>
                        </div>
                        <div style="font-size: 12px;">{{ legendItem.label }}</div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="middle-section">
            <span class="chart-heading">Trainings</span>
            <div class="pie-chart2">
                <p-chart
                    style="margin-bottom: 10px;"
                    type="pie"
                    #chart2
                    [data]="trainingChartData"
                    [options]="trainingChartOptions"
                    height="280px"
                    width="280px"
                />
                <ul class="custom-legend" style="display: flex;">
                    <li
                        *ngFor="let legendItem of legendItemsForTraining; let i = index"
                        (click)="onTrainingLegendItemClick(legendItem.label, i)"
                    >
                        <span
                            class="legend-marker"
                            [style.backgroundColor]="legendItem.color"
                        ></span>
                        {{ legendItem.label }}
                    </li>
                </ul>
            </div>
        </div>
        <div class="right-section">
            <span class="top-trainings-header">Top Trainings</span>
            <ul class="top-trainings-list">
                <ng-container *ngFor="let training of topTrainings">
                    <li
                        class="top-trainings-item"
                        [title]="training.programName"
                        (click)="OnTopTrainingListItemClick(training?.programId)"
                    >
                        {{ training.programName | slice:0:24 }}{{ training.programName.length > 25 ? '...' : '' }}
                    </li>
                </ng-container>    
            </ul>
        </div>
    </div>
    <div class="bottom-section">
        <div class="bottom-header">
            <span>Employee Skills - {{ highlightedLabel }}</span>
            <div>
                <button
                    class="initiateBtn"
                    style="width: 100px; margin-right: 10px;"
                    (click)="exportData()"
                >
                    Export
                </button>
                <button
                    class="initiateBtn"
                    [disabled]="!isEmployeeSelcted()"
                    [class.disabled]="!isEmployeeSelcted()"
                    (click)="openInitiateTraining()"
                    [ngStyle]="{opacity: isEmployeeSelcted() ? '1' : '0.5'}"
                >
                    Initiate Trainings
                </button>
            </div>
        </div>
        <div>
            <table
                style="width: 100%; table-layout: fixed;"
                mat-table
                [dataSource]="tableData"
                class="m-1"
            >
                <ng-container matColumnDef="checkBox">
                    <th mat-header-cell *matHeaderCellDef class="alignment">
                        <mat-checkbox
                            class="check-box"
                            [(ngModel)]="isAllSelected"
                            (ngModelChange)="processAllSelected($event)"
                        ></mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row" class="">
                        <mat-checkbox
                            class="check-box"
                            style="width: 100%;"
                            [(ngModel)]="row.isChecked"
                            (ngModelChange)="processCheckEvent($event, row)"
                        ></mat-checkbox>
                    </td>
                </ng-container>
                <ng-container matColumnDef="employeeId">
                    <th mat-header-cell *matHeaderCellDef class="alignment">
                        Employee Id
                    </th>
                    <td mat-cell *matCellDef="let row" class="">
                        <div
                            class="truncateValue"
                            [ngbTooltip]="projectNameTooltip"
                            tooltipClass="custom_tooltip"
                            triggers="manual"
                            #tooltip="ngbTooltip"
                            (mouseleave)="tooltip.close()"
                            (mouseover)="tooltip.open()"
                        >
                            <ng-template #projectNameTooltip class="custom_tooltip">
                                {{row.employeeId}}
                            </ng-template>
                            {{row.employeeId}}
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="firstName">
                    <th mat-header-cell *matHeaderCellDef>First Name</th>
                    <td mat-cell *matCellDef="let row">
                        <div
                            class="truncateValue"
                            [ngbTooltip]="projectNameTooltip"
                            tooltipClass="custom_tooltip"
                            triggers="manual"
                            #tooltip="ngbTooltip"
                            (mouseleave)="tooltip.close()"
                            (mouseover)="tooltip.open()"
                        >
                            <ng-template #projectNameTooltip class="custom_tooltip">
                                {{row.firstName}}
                            </ng-template>
                            {{row.firstName}}
                        </div>
                    </td>
                </ng-container>
        
                <ng-container matColumnDef="lastName">
                    <th mat-header-cell *matHeaderCellDef>Last Name</th>
                    <td mat-cell *matCellDef="let row">
                        <div
                            class="truncateValue"
                            [ngbTooltip]="projectNameTooltip"
                            tooltipClass="custom_tooltip"
                            triggers="manual"
                            #tooltip="ngbTooltip"
                            (mouseleave)="tooltip.close()"
                            (mouseover)="tooltip.open()"
                        >
                            <ng-template #projectNameTooltip class="custom_tooltip">
                                {{row.lastName}}
                            </ng-template>
                            {{row.lastName}}
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="skillType">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="filter-heading">
                            <div>Skill Type</div>
                            <ng-container
                                *ngTemplateOutlet="
                                    filterTemplate;
                                    context: { head: { Name: 'skillType' }, options: filteredList.skillType }
                                "
                            ></ng-container>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <div
                            class="truncateValue"
                            [ngbTooltip]="projectNameTooltip"
                            tooltipClass="custom_tooltip"
                            triggers="manual"
                            #tooltip="ngbTooltip"
                            (mouseleave)="tooltip.close()"
                            (mouseover)="tooltip.open()"
                        >
                            <ng-template #projectNameTooltip class="custom_tooltip">
                                {{row.skillType}}
                            </ng-template>
                            {{row.skillType}}
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="level">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="filter-heading">
                            <div>Level</div>
                            <ng-container
                                *ngTemplateOutlet="
                                    filterTemplate;
                                    context: { head: { Name: 'level' } , options: filteredList.level}
                                "
                            ></ng-container>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <div
                            class="truncateValue"
                            [ngbTooltip]="projectNameTooltip"
                            tooltipClass="custom_tooltip"
                            triggers="manual"
                            #tooltip="ngbTooltip"
                            (mouseleave)="tooltip.close()"
                            (mouseover)="tooltip.open()"
                        >
                            <ng-template #projectNameTooltip class="custom_tooltip">
                                {{proficiencyLevel[row.level] ?? 'Expert'}}
                            </ng-template>
                            {{proficiencyLevel[row.level] ?? 'Expert'}}
                        </div>
                    </td>
                </ng-container>
        
                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef> Email </th>
                    <td mat-cell *matCellDef="let row">
                        <div
                            class="truncateValue"
                            [ngbTooltip]="projectNameTooltip"
                            tooltipClass="custom_tooltip"
                            triggers="manual"
                            #tooltip="ngbTooltip"
                            (mouseleave)="tooltip.close()"
                            (mouseover)="tooltip.open()"
                        >
                            <ng-template #projectNameTooltip class="custom_tooltip">
                                {{row.email}}
                            </ng-template>
                            {{row.email}}
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="skills">
                    <th mat-header-cell *matHeaderCellDef> Skills </th>
                    <td mat-cell *matCellDef="let row">
                        <div
                            class="truncateValue"
                            [ngbTooltip]="projectNameTooltip"
                            tooltipClass="custom_tooltip"
                            triggers="manual"
                            #tooltip="ngbTooltip"
                            (mouseleave)="tooltip.close()"
                            (mouseover)="tooltip.open()"
                        >
                            <ng-template #projectNameTooltip class="custom_tooltip">
                                {{row.skills}}
                            </ng-template>
                            {{row.skills}}
                        </div>
                    </td>
                </ng-container>
        
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                    mat-row
                    [class.odd]="i % 2 == 1"
                    [class.even]="i % 2 == 0"
                    *matRowDef="let row; columns: displayedColumns; let i = index;"
                ></tr>
            </table>
            <div *ngIf="!tableData.length" style="text-align: center;">
                No Records Found
            </div>
    
            <mat-paginator
                [length]="totalRecords"
                [pageSize]="10"
                [pageSizeOptions]="[10,20,40,50,60]"
                aria-label="Select page"
                (page)="getPaginatorData($event)"
                style="height: 8vh; background: inherit; width: 98%; margin-left: 16px;"
            ></mat-paginator>
        </div> 
    </div>
</div>

<ng-template #filterTemplate let-head="head" let-options="options">
    <div>
        <span
            class="material-symbols-outlined filter-icon"
            (click)="openCloseFilter(head.Name)"
        >
            filter_alt
        </span>
    </div>
    <div
        class="filter-container"
        tabindex="1"
        *ngIf="filterOptions[head.Name]"
    >
        <div>
            <span
                class="material-symbols-outlined clearIcon"
                (click)="openCloseFilter(head.Name)"
            >
                close
            </span>
        </div>
        <div class="filterOptions" *ngFor="let option of options">
            <mat-checkbox
                class="check-box"
                [(ngModel)]="option.isChecked"
                (ngModelChange)="onOptionChange($event, option, head.Name)"
            >{{option.name}}</mat-checkbox>
        </div>
    </div>
</ng-template>